import { parcelPhotoIdFormat } from "@redotech/redo-fulfillment-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Soft-deletes a parcel photo by setting `deletedAt`. The S3 object
 * lingers for a retention window so admin tooling can undo accidental
 * deletes; a sweeper job purges the bytes after the window expires.
 *
 * Allowed for any user with access to the FG. Audit logging happens
 * in the handler.
 */
export const deleteParcelPhoto = {
  name: "deleteParcelPhoto" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    photoId: parcelPhotoIdFormat.schema,
  }),
  output: z.object({ success: z.boolean() }),
};
